import store from '../../../createStore';

const shouldValidatePostalCode = () => {
  const sourceConfig = store().getState().authReducer.appConfig;

  return sourceConfig.validate_avs;
};

export default shouldValidatePostalCode;
